import { createFileRoute } from "@tanstack/react-router";
import { WebDevelopmentServicePage } from "./services_.web-development";

export const Route = createFileRoute("/services_/web-development-services")({
  head: () => ({
    meta: [
      {
        title: "Web Development Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Custom Web Development & Conversion-Optimized UX.",
      },
    ],
  }),
  component: WebDevelopmentServicePage,
});
